/*
 *  Copyright (c) Qwoach LLC 2021. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/11/2021
 */
import mergeProps from "@/router/utils/mergeProps";
import redirectByName from "@/router/utils/redirectByName.js";

let AdminTeamDetailsPage = () => import(/* webpackChunkName: "ClientsModule" */ "@/core/modules/coach/Profile/Team/Details/AdminTeamDetailsPage.vue");
let CoachTeamDetailsPage = () => import(/* webpackChunkName: "ClientsModule" */ "@/core/modules/coach/Profile/Team/Details/CoachTeamDetailsPage.vue");
let TeamMemberRedirectPage = () => import(/* webpackChunkName: "ClientsModule" */ "@/core/modules/coach/Profile/Team/Details/TeamMemberRedirectPage.vue");

let EmptyRouterView = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/components/EmptyRouterView.vue')
let ClientDetailsMain = () => import(/* webpackChunkName: "ClientsModule" */ '@/core/recoveryCoachingApp/coach/clients/ClientDetails/ClientDetailsMain.vue')


export default [

	{
		path: ':profileId/details',
		redirect: redirectByName('TeamMemberDetailsMainTabs'),
		component: EmptyRouterView,
		props: true,
		children: [
			{
				path: 'admin/:activeTab',
				name: 'AdminTeamDetailsRoute',
				component: AdminTeamDetailsPage,
			},
			{
				path: 'coach/:activeTab',
				name: 'CoachTeamDetailsRoute',
				component: CoachTeamDetailsPage,
			},

			{
				path: '',
				name: 'TeamMemberDetailsRoute',
				props: true,
				component: TeamMemberRedirectPage,
			},


		]
	},




]


